import React, { useRef } from 'react';
import { getImageUrlSingleAxis } from './getImageUrl';
import useNodeSize from './useNodeSize';
import usePixelRatio from './usePixelRatio';
function ResizeImageDivImpl(props) {
    const { src, width, maxWidth, aspect, quality, useHeight, style, ...otherProps } = props;
    const nodeRef = useRef(null);
    const pixelRatio = usePixelRatio();
    const actualSize = useNodeSize(nodeRef, width != null ? [width, width] : undefined);
    function getUrl(multiplier = 1) {
        if (actualSize == null)
            return undefined;
        const nextSize = actualSize.map((v) => {
            const value = v * multiplier;
            if (maxWidth != null && maxWidth < value)
                return maxWidth;
            return value;
        });
        if (useHeight) {
            return getImageUrlSingleAxis(src, nextSize[1], aspect, quality, true);
        }
        return getImageUrlSingleAxis(src, nextSize[0], aspect, quality, false);
    }
    const imageUrl = getUrl(pixelRatio);
    return (React.createElement("div", Object.assign({}, otherProps, { ref: nodeRef, style: imageUrl != null
            ? {
                ...style,
                backgroundImage: `url(${imageUrl})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
            }
            : style })));
}
export const ResizeImageDiv = React.memo(ResizeImageDivImpl);
//# sourceMappingURL=ResizeImageDiv.js.map